import {Component, Input} from '@angular/core';
import {ServicesDeliveryService} from '../../../../services/services-delivery.service';
import {UserService} from '../../../../services/user.service';

@Component({
  selector: 'info',
  templateUrl: './info.component.html'
})

export class InfoComponent {
}



// WEBPACK FOOTER //
// ./src/app/modules/users/components/info/info.component.ts